import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddIcon from "../../Assets/svgs/AddIcon";
import { AssistantIcon } from "../../Assets/svgs/AssistantIcon";
import DeleteIcon from "../../Assets/svgs/DeleteIcon";
import EyeButtonIcon from "../../Assets/svgs/EyeButtonIcon";
import PdfIcon from "../../Assets/svgs/PdfIcon";
import { debounce } from "../../Common/debounce";
import { Loader } from "../../Common/Loader";
import useDebounce from "../../Common/useDebounce";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { getAssistantDocumentsList } from "../../Redux/Slice/Documents/AssistantDocumentListSlice";
import { removeAssistantFromDocument } from "../../Redux/Slice/Documents/RemoveAssistantFromDocumentSlice";
import AssistantUploadDocumentModal from "../../Model/AssistantUploadDocumentModal";
import { downloadFile, downloadFileAsBlob } from "../../Common/utils";
import moment from "moment";
import TxtIcon from "../../Assets/svgs/TxtIcon";
import MarkdownIcon from "../../Assets/svgs/MarkdownIcon";
import WordIcon from "../../Assets/svgs/WordIcon";
import ModernPdfIcon from "../../Assets/svgs/ModernPdfIcon";
import KnowledgeBaseIcon from "../../Assets/svgs/KnowledgeBaseIcon";

const AssistantDocumentsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 1000);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [selectedRow, setselectedRow] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const knowledgeBaseListData = useSelector(
    (state) => state.documentList.documentsListData
  );
  const [showUploadDocument, setShowUploadDocument] = useState({
    visible: false,
    data: null,
    isView: false,
  });

  const getDocumentsList = async (page = 1) => {
    setIsLoading(true);
    await dispatch(
      getAssistantDocumentsList({ searchText, page: 1, limit: 200 })
    );
    setIsLoading(false);
  };

  const documentsList = useMemo(() =>
    knowledgeBaseListData &&
    knowledgeBaseListData?.data &&
    Array.isArray(knowledgeBaseListData?.data)
      ? knowledgeBaseListData?.data
      : []
  );

  useEffect(() => {
    getDocumentsList();
  }, [searchQuery]);

  const onEdit = (rowData) => {};
  const onDelete = (rowData) => {
    setselectedRow(rowData);
    setCOnfirmModel(true);
  };

  const onDeleteConfirm = async () => {
    setIsLoading(true);
    setCOnfirmModel(false);
    const result = await dispatch(removeAssistantFromDocument(selectedRow.id));
    if (
      removeAssistantFromDocument.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Contact Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getDocumentsList(1);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onAddDocument = () => {
    setShowUploadDocument({
      visible: true,
      data: null,
      isView: false,
    });
  };

  const onViewDocument = (data) => {
    setShowUploadDocument({
      visible: true,
      data: data,
      isView: true,
    });
  };

  const onCloseUploadDocument = () => {
    setShowUploadDocument({
      visible: false,
      data: null,
      isView: false,
    });
  };

  const onSuccessUploadDocument = () => {
    onCloseUploadDocument();
    getDocumentsList();
  };

  const onRemoveAssignedAssistant = async (fileId, assistant) => {
    const body = {
      fileId: fileId,
      assistantId: assistant?.vapiAssistanceId,
    };
    setIsLoading(true);
    try {
      const result = await dispatch(removeAssistantFromDocument(body));
      if (
        removeAssistantFromDocument.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        setSuccessMessage("Assistant has been successfully unassigned!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
          getDocumentsList();
        }, 1500);
      } else {
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="page__body">
        {errorModel ? <ErrorModel message={errorMessage} /> : ""}
        {successModel ? <SuccessModel message={successMessage} /> : ""}
        {isLoading ? <Loader /> : ""}
        {confirmModel ? (
          <ConfirmModel
            onAccept={onDeleteConfirm}
            onReject={() => {
              setCOnfirmModel(false);
            }}
            title="Delete Contact!"
            message="Are you sure you want to Delete the contact?"
          />
        ) : (
          ""
        )}
        {showUploadDocument.visible ? (
          <AssistantUploadDocumentModal
            visible={showUploadDocument.visible}
            data={showUploadDocument.data}
            isView={showUploadDocument.isView}
            onClose={onSuccessUploadDocument}
            onSuccess={onSuccessUploadDocument}
          />
        ) : null}

        {(Array.isArray(documentsList) && documentsList?.length) ||
        (searchQuery && searchQuery?.length) ? (
          <div className="documentWrap">
            <div className="documentWrap__head">
              <div className="formRow m_0 w_100 formRow--flexEnd">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    placeholder="Search a Document"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              </div>
              <div className="btn__group">
                <button className="btn btn__primary" onClick={onAddDocument}>
                  <AddIcon />
                  Add {documentsList?.length ? "More Documents" : "Document"}
                </button>
              </div>
            </div>
            <div className="documentWrap__list">
              {Array.isArray(documentsList) && documentsList?.length ? (
                documentsList?.map((document, index) => (
                  <div className="documentWrap__list__item">
                    <div className="documentWrap__card">
                      <div className="documentWrap__card__head">
                        <h3 className="title">{document?.name}</h3>
                        <span
                          className="btnView"
                          onClick={() => onViewDocument(document)}
                        >
                          <EyeButtonIcon />
                        </span>
                      </div>
                      <div className="documentWrap__card__body">
                        <div className="documentsBox">
                          <div className="documentsBox__document">
                            <div className="pic">
                              {document?.thumbnail ? (
                                <img src={document?.thumbnail} alt="" />
                              ) : document?.mimetype == "text/plain" ? (
                                <TxtIcon />
                              ) : document?.mimetype == "text/markdown" ? (
                                <MarkdownIcon />
                              ) : document?.mimetype == "application/msword" ||
                                document?.mimetype ==
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                <WordIcon />
                              ) : (
                                <ModernPdfIcon />
                              )}
                            </div>
                            <h3 className="title">
                              {document?.mimetype == "text/plain" ? (
                                <TxtIcon width={10} height={11} />
                              ) : document?.mimetype == "text/markdown" ? (
                                <MarkdownIcon width={10} height={11} />
                              ) : document?.mimetype == "application/msword" ||
                                document?.mimetype ==
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                <WordIcon width={10} height={11} />
                              ) : (
                                <PdfIcon />
                              )}
                              {document?.name}
                            </h3>
                          </div>
                          <div className="documentsBox__content">
                            <p className="para">
                              <strong>Document Name</strong> {document?.name}
                            </p>
                            <p className="para">
                              <strong>Uploaded By</strong>{" "}
                              {document?.createdBy?.firstName}{" "}
                              {document?.createdBy?.lastName}
                            </p>
                            <p className="para">
                              <strong>Uploaded Date</strong>{" "}
                              {moment
                                .utc(document?.createdAt)
                                .local()
                                .format("DD-MM-YYYY, hh:mm A")}
                            </p>
                          </div>
                        </div>
                        {/* <ul className="list">
                          {Array.isArray(document?.assistants)
                            ? document?.assistants?.map((assistant) => (
                                <li className="list__item">
                                  <span className="text">
                                    <span className="icon">
                                      <AssistantIcon />
                                    </span>
                                    {assistant?.name}
                                  </span>
                                  <button
                                    className="btn border_0 p_0"
                                    onClick={() =>
                                      onRemoveAssignedAssistant(
                                        document?.id,
                                        assistant
                                      )
                                    }
                                  >
                                    <DeleteIcon />
                                  </button>
                                </li>
                              ))
                            : null}
                        </ul> */}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-data">
                  {searchQuery?.length ? "No Document Found!" : "No Document!"}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="createAssistant">
            <div className="createAssistant__card">
              <div className="createAssistant__details">
                <h2 className="title">Add Document</h2>
                <div className="icon">
                  <KnowledgeBaseIcon />
                </div>
                <p className="para">
                  You can upload PDFs and other file types to provide additional
                  context for your assistants during conversations.
                </p>
                <div className="btn__group">
                  <button className="btn btn__primary" onClick={onAddDocument}>
                    <AddIcon />
                    Add Document
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssistantDocumentsList;
